import React, { useEffect, useState } from "react";
import Form, {
  Item,
  RequiredRule,
  Label,
  GroupItem,
  StringLengthRule,
} from "devextreme-react/form";
import { SelectBox } from "devextreme-react";
import { formatMessage } from "devextreme/localization";
import { useSelector, useDispatch } from "react-redux";
import { responseDepartment } from "../../../redux/reducers";
import { showDepartment } from "../../../redux/actions";
import Guid from "devextreme/core/guid";
import "./style.scss";
import { listApprovalType, changeDisplayedName } from "../../../common";

export default function FormApprovalSetting({ formData }) {
  const [approvalType, setApprovalType] = useState("");
  const [departmentType, setDepartmentType] = useState();
  const dispatch = useDispatch();
  const { department } = useSelector(responseDepartment);

  useEffect(() => {
    dispatch(showDepartment());
  }, [dispatch]);

  useEffect(() => {
    if (formData.current.Department) {
      const newDepartmentOid = new Guid(formData.current.Department.Oid);
      setDepartmentType(newDepartmentOid);
      formData.current.DepartmentOid = newDepartmentOid;
    }
  }, [formData, formData.current.Department]);

  function gridBoxDepartmentDisplayExpr(item) {
    return item && `${item.DepartmentCode} - ${item.DepartmentName}`;
  }

  const dataTypeEditorOptions = {
    items: listApprovalType,
    searchEnabled: true,
    value: approvalType,
    displayExpr: changeDisplayedName(),
    valueExpr: "id",
    placeholder: formatMessage("PlaceholderApprovalType"),
    searchMode: "contains",
    showClearButton: true,
    onValueChanged: (e) => {
      setApprovalType(e.value);
    },
  };

  return (
    <div>
      <Form
        colCount={2}
        id="form"
        formData={formData.current}
        focusStateEnabled={true}
        className={"form-editor"}
        onContentReady={(e) => {
          e.component.focus();
        }}
      >
        <GroupItem>
          <Item
            dataField="ApprovalType"
            editorType="dxSelectBox"
            editorOptions={dataTypeEditorOptions}
          >
            <Label text={formatMessage("ApprovalType")} />
            <RequiredRule message={formatMessage("ValidateApprovalType")} />
          </Item>

          <Item dataField="Department">
            <Label text={formatMessage("Departments")} />
            <SelectBox
              valueExpr="Oid"
              dataSource={department}
              value={departmentType}
              displayExpr={gridBoxDepartmentDisplayExpr}
              itemRender={gridBoxDepartmentDisplayExpr}
              onValueChanged={(e) => {
                formData.current.DepartmentOid = e.value;
                setDepartmentType(e.value);
              }}
              searchEnabled={true}
            />

            <RequiredRule message="Vui lòng nhập dữ liệu" />
          </Item>
        </GroupItem>
        <GroupItem>
          <Item dataField="Description" editorType="dxTextBox">
            <StringLengthRule max="250" />
            <Label text={formatMessage("Description")} />
          </Item>
          <Item dataField="IsActive" editorType="dxCheckBox">
            <Label text={formatMessage("IsActive")} />
          </Item>
        </GroupItem>
      </Form>
    </div>
  );
}
